// @flow

import React from 'react'
import renderHTML from 'react-render-html'
import './styles.scss'

type Props = {
  trackingID?: string,
  shortText: string,
  longText: string,
  title: string
}

export default class Chart extends React.Component<Props, null> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isExpanded: false
    }
    this.toggleMore = this.toggleMore.bind(this)
  }

  toggleMore(e) {
    e.preventDefault()
    if (this.state.isExpanded) {
      this.setState({
        isExpanded: false
      })
    } else {
      this.setState({
        isExpanded: true
      })
    }
  }

  render() {
    return (
      <div className='chart-wrapper'>
        <h5>{this.props.title}</h5>
        <div
          className={
            this.state.isExpanded
              ? 'chart-info expanded'
              : 'chart-info collapsed'
          }
        >
          <div className='intro-text'>{renderHTML(this.props.shortText)}</div>
          {/* wether or not to render "more"-section */}
          {false && (
            <>
              <div className='show-more'>
                <a
                  onClick={this.toggleMore}
                  data-person={this.props.trackingID}
                >
                  <i className='grey text file icon' />
                  Mehr...
                  <i className='chevron right icon small' />
                </a>
              </div>
              <div className='additional-text'>
                {/* <span className='hint'>Auszug eines längeren Interviews</span> */}
                {renderHTML(this.props.longText)}
              </div>
              <div className='show-less'>
                <a onClick={this.toggleMore}>
                  schliessen <i className='chevron up icon small' />
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    )
  }
}
